export default __webpack_public_path__ + "static/sink-sumbat-40876ce20173908636e11d05fa230221.mp4";